import i18n from "i18next";
import webapp from "./en/webapp.json";
import shared from "./en/shared.json";
import governance from "./en/governance.json";
import { initReactI18next } from "react-i18next";
export var resources = {
    en: {
        webapp: webapp,
        shared: shared,
        governance: governance,
    },
};
i18n.use(initReactI18next).init({
    lng: "en",
    interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
    },
    resources: resources,
});
//# sourceMappingURL=config.js.map